import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('cp-confirm-dialog')
export class CpConfirmDialog extends LitElement {
  createRenderRoot() { return this; }

  @property({ type: Boolean }) open = false;
  @property({ type: String }) title = 'Bestaetigen';
  @property({ type: String }) message = '';
  @property({ type: String }) confirmLabel = 'Bestaetigen';
  @property({ type: String }) variant: 'primary' | 'danger' = 'primary';

  connectedCallback(): void {
    super.connectedCallback();
    document.addEventListener('keydown', this._onKeyDown);
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    document.removeEventListener('keydown', this._onKeyDown);
  }

  private _onKeyDown = (e: KeyboardEvent): void => {
    if (e.key === 'Escape' && this.open) {
      this._cancel();
    }
  };

  private _cancel(): void {
    this.dispatchEvent(new CustomEvent('dialog-cancelled', { bubbles: true, composed: true }));
  }

  private _confirm(): void {
    this.dispatchEvent(new CustomEvent('dialog-confirmed', { bubbles: true, composed: true }));
  }

  private _onBackdropClick(e: Event): void {
    if (e.target === e.currentTarget) {
      this._cancel();
    }
  }

  render() {
    if (!this.open) return nothing;

    const confirmClass = this.variant === 'danger'
      ? 'cp-confirm-dialog__btn cp-confirm-dialog__btn--danger'
      : 'cp-confirm-dialog__btn cp-confirm-dialog__btn--confirm';

    return html`
      <div class="cp-confirm-dialog__overlay" @click=${this._onBackdropClick}>
        <div class="cp-confirm-dialog__dialog">
          <div class="cp-confirm-dialog__header">
            <h2 class="cp-confirm-dialog__heading">${this.title}</h2>
            <button class="cp-confirm-dialog__close" @click=${this._cancel}>&times;</button>
          </div>
          <div class="cp-confirm-dialog__body">
            <p class="cp-confirm-dialog__message">${this.message}</p>
          </div>
          <div class="cp-confirm-dialog__footer">
            <button class="cp-confirm-dialog__btn cp-confirm-dialog__btn--cancel" @click=${this._cancel}>Abbrechen</button>
            <button class="${confirmClass}" @click=${this._confirm}>${this.confirmLabel}</button>
          </div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-confirm-dialog': CpConfirmDialog;
  }
}
